import React from "react";
import styled from "styled-components";
const Svg = styled.svg`
  height: 1em;
`;
export const HomeIcon = () => (
  <Svg
    className="svg-inline--fa fa-house-blank"
    aria-hidden="true"
    focusable="false"
    data-prefix="far"
    data-icon="house-blank"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
    data-fa-i2svg=""
  >
    <path
      fill="currentColor"
      d="M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V245.5l24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM464 204.8V432c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V204.8L288 55.5 464 204.8z"
    ></path>
  </Svg>
);

export const FaqIcon = () => (
  <Svg
    className="svg-inline--fa fa-message-question"
    aria-hidden="true"
    focusable="false"
    data-prefix="far"
    data-icon="message-question"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    data-fa-i2svg=""
  >
    <path
      fill="currentColor"
      d="M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM169.8 117.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V216c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6c-23.7 0-44.8 14.9-52.8 37.3zM288 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ></path>
  </Svg>
);
export const ContactIcon = () => (
  <Svg
    className="svg-inline--fa fa-messages"
    aria-hidden="true"
    focusable="false"
    data-prefix="far"
    data-icon="messages"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 512"
    data-fa-i2svg=""
  >
    <path
      fill="currentColor"
      d="M48 72c0-13.3 10.7-24 24-24H344c13.3 0 24 10.7 24 24V248c0 13.3-10.7 24-24 24H216c-4.7 0-9.4 1.4-13.3 4L144 315.2V296c0-13.3-10.7-24-24-24H72c-13.3 0-24-10.7-24-24V72zM72 0C32.2 0 0 32.2 0 72V248c0 39.8 32.2 72 72 72H96v40c0 8.9 4.9 17 12.7 21.2s17.3 3.7 24.6-1.2l90-60H344c39.8 0 72-32.2 72-72V72c0-39.8-32.2-72-72-72H72zM256 376c0 39.8 32.2 72 72 72h88.7l90 60c7.4 4.9 16.8 5.4 24.6 1.2S544 496.9 544 488V448h24c39.8 0 72-32.2 72-72V200c0-39.8-32.2-72-72-72H448v48H568c13.3 0 24 10.7 24 24V376c0 13.3-10.7 24-24 24H520c-13.3 0-24 10.7-24 24v19.2L437.3 404c-3.9-2.6-8.6-4-13.3-4H328c-13.3 0-24-10.7-24-24V352H256v24z"
    ></path>
  </Svg>
);
export const ContactLargeIcon = () => (
  <Svg
    className="svg-inline--fa fa-messages"
    aria-hidden="true"
    focusable="false"
    data-prefix="fal"
    data-icon="messages"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 512"
    data-fa-i2svg=""
  >
    <path
      fill="currentColor"
      d="M576 128H448v32h128c17.64 0 32 14.36 32 32v192c0 17.64-14.36 32-32 32h-64v49.57L424.4 416H320c-17.64 0-32-14.36-32-32v-32l-32-.0039v31.98c0 35.25 28.75 63.1 63.1 63.1L416 448l108.9 61.63C527.1 511.3 529.6 512 532 512C538.3 512 544 507.1 544 500v-52.03h32c35.25 0 64-28.75 64-63.1V191.1C640 156.7 611.3 128 576 128zM416 256V63.1C416 28.75 387.3 0 352 0H64C28.75 0 0 28.75 0 63.1v192C0 291.3 28.75 320 64 320l32 .0106V372C96 379.1 101.8 384 108 384c2.375 0 4.875-.75 7.125-2.375L224 320l128-.075C387.3 319.9 416 291.3 416 256zM215.6 288L128 337.6V288H64C46.36 288 32 273.6 32 256V64c0-17.64 14.36-32 32-32h288c17.64 0 32 14.36 32 32v192c0 17.64-14.36 32-32 32H215.6z"
    ></path>
  </Svg>
);
export const SettingsIcon = () => (
  <Svg className="svg-inline--fa fa-gear" aria-hidden="true" focusable="false" data-prefix="far" data-icon="gear" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg="">
    <path
      fill="currentColor"
      d="M208.1 51.4C220.3 49.2 233 48 246 48s25.7 1.2 37.9 3.4l8.5 35.1c4.1 17 15.6 29.8 28.9 37.4l1.4 .8c13.2 7.7 30.1 11.3 46.9 6.4l34.6-10.2c7.4 8.7 14.2 18 20.1 27.8l4 6.9c5.4 9.8 10.1 20.2 13.9 30.9l-26.2 24.9c-12.7 12-18 28.4-17.9 43.7l0 .8 0 .8c-.1 15.3 5.3 31.6 17.9 43.7l26.2 24.9c-3.8 10.7-8.5 21.1-13.9 30.9l-4 6.9c-5.9 9.8-12.7 19.1-20.1 27.8l-34.6-10.2c-16.8-5-33.7-1.4-46.9 6.4l-1.4 .8c-13.2 7.6-24.8 20.4-28.9 37.4l-8.5 35.1c-12.3 2.3-25 3.4-37.9 3.4s-25.7-1.2-37.9-3.4l-8.5-35.1c-4.1-17-15.6-29.8-28.9-37.4l-1.4-.8c-13.2-7.7-30.1-11.3-46.9-6.4L87.9 391.1c-7.4-8.7-14.2-18-20.1-27.8l-4-7c-5.4-9.8-10.1-20.2-13.9-30.9l26.2-24.9c12.7-12 18-28.4 17.9-43.7l0-.8 0-.8c.1-15.3-5.3-31.6-17.9-43.7L49.9 186.6c3.8-10.7 8.5-21.1 13.9-30.9l4-6.9c5.9-9.8 12.7-19.1 20.1-27.8l34.6 10.2c16.8 5 33.7 1.4 46.9-6.4l1.4-.8c13.2-7.6 24.8-20.4 28.9-37.4l8.5-35.1zM246 0c-17 0-33.6 1.7-49.8 4.8c-7.9 1.5-21.8 6.1-29.4 20.1c-2 3.7-3.6 7.6-4.6 11.8l-9.3 38.5c-.5 2-2.2 4.8-6 7c-.6 .4-1.2 .7-1.9 1.1c-3.8 2.2-7 2.3-9.1 1.7L98 73.8c-4-1.2-8.1-1.8-12.2-1.9c-16.1-.5-27 9.4-32.3 15.4c-10 11.4-19 23.8-26.9 36.9l0 0-.2 .4-4.2 7.3 0 0-.2 .4c-7.3 13.1-13.4 26.9-18.3 41.3C1 181.1-2 195.3 6.2 208.9c2.2 3.6 4.9 7 8 10L43 246.3c1.5 1.5 3 4.3 3 8.7l0 1.1 0 1.1c0 4.3-1.5 7.2-3 8.7L14.2 293.1c-3.1 3-5.8 6.4-8 10C-2 316.7 1 330.9 3.6 338.4c4.9 14.4 11 28.2 18.3 41.3l0 0 .2 .4 4.3 7.4 0 0 .2 .4c7.9 13.1 16.9 25.4 26.9 36.8c5.3 6 16.3 15.9 32.3 15.4c4.1-.1 8.2-.8 12.2-1.9L136 427c2-.6 5.3-.5 9.1 1.7c.6 .4 1.2 .7 1.9 1.1c3.8 2.2 5.5 4.9 6 7l9.3 38.5c1 4.2 2.6 8.2 4.6 11.8c7.7 14 21.6 18.5 29.4 20.1c16.1 3.2 32.8 4.8 49.8 4.8s33.6-1.7 49.8-4.8c7.9-1.5 21.8-6.1 29.4-20.1c2-3.7 3.6-7.6 4.6-11.8l9.3-38.5c.5-2 2.2-4.8 6-7c.6-.4 1.2-.7 1.9-1.1c3.8-2.2 7-2.3 9.1-1.7l38 11.2c4 1.2 8.1 1.8 12.2 1.9c16.1 .5 27-9.4 32.3-15.4c10-11.4 19-23.8 26.9-36.9l0 0 .2-.4 4.2-7.3 0 0 .2-.4c7.3-13.1 13.4-26.9 18.3-41.3c2.6-7.6 5.6-21.8-2.7-35.4c-2.2-3.6-4.9-7-8-10L449 265.7c-1.5-1.5-3-4.3-3-8.7l0-1.1 0-1.1c0-4.3 1.5-7.2 3-8.7l28.7-27.3c3.1-3 5.8-6.4 8-10c8.2-13.6 5.2-27.8 2.7-35.4c-4.9-14.4-11-28.2-18.3-41.3l0 0-.2-.4-4.2-7.3 0 0-.2-.4c-7.9-13.1-16.9-25.4-26.9-36.9c-5.3-6-16.3-15.9-32.3-15.4c-4.1 .1-8.2 .8-12.2 1.9L356 85c-2 .6-5.3 .5-9.1-1.7c-.6-.4-1.2-.7-1.9-1.1c-3.8-2.2-5.5-4.9-6-7l-9.3-38.5c-1-4.2-2.6-8.2-4.6-11.8c-7.7-14-21.6-18.5-29.4-20.1C279.6 1.7 263 0 246 0zM198 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm144 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"
    ></path>
  </Svg>
);
export const MenuIcon = () => (
  <Svg className="svg-inline--fa fa-bars" aria-hidden="true" focusable="false" data-prefix="far" data-icon="bars" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg="">
    <path
      fill="currentColor"
      d="M0 88C0 74.7 10.7 64 24 64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 112 0 101.3 0 88zM0 248c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM448 408c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H424c13.3 0 24 10.7 24 24z"
    ></path>
  </Svg>
);
export const CloseIcon = () => (
  <Svg
    className="svg-inline--fa fa-xmark"
    aria-hidden="true"
    focusable="false"
    data-prefix="far"
    data-icon="xmark"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 320 512"
    data-fa-i2svg=""
  >
    <path
      fill="currentColor"
      d="M313 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L41 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L7 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L279 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L313 137z"
    ></path>
  </Svg>
);
export const LogoutIcon = () => (
  <Svg
    className="svg-inline--fa fa-arrow-right-from-bracket"
    aria-hidden="true"
    focusable="false"
    data-prefix="far"
    data-icon="arrow-right-from-bracket"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    data-fa-i2svg=""
  >
    <path
      fill="currentColor"
      d="M505 273c9.4-9.4 9.4-24.6 0-33.9L377 111c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l87 87L184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l246.1 0-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 273zM168 80c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 32C39.4 32 0 71.4 0 120L0 392c0 48.6 39.4 88 88 88l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l80 0z"
    ></path>
  </Svg>
);
export const DateIcon = () => (
  <Svg
    className="svg-inline--fa fa-calendar"
    aria-hidden="true"
    focusable="false"
    data-prefix="fal"
    data-icon="calendar"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    data-fa-i2svg=""
  >
    <path
      fill="currentColor"
      d="M112 0C120.8 0 128 7.164 128 16V64H320V16C320 7.164 327.2 0 336 0C344.8 0 352 7.164 352 16V64H384C419.3 64 448 92.65 448 128V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V128C0 92.65 28.65 64 64 64H96V16C96 7.164 103.2 0 112 0zM416 192H32V448C32 465.7 46.33 480 64 480H384C401.7 480 416 465.7 416 448V192zM384 96H64C46.33 96 32 110.3 32 128V160H416V128C416 110.3 401.7 96 384 96z"
    ></path>
  </Svg>
);
export const FileIcon = () => (
  <Svg
    className="svg-inline--fa fa-marker"
    aria-hidden="true"
    focusable="false"
    data-prefix="fal"
    data-icon="marker"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    data-fa-i2svg=""
  >
    <path
      fill="currentColor"
      d="M294.6 61.25C291.2 57.85 287.2 55.37 282.1 53.82C271.7 49.69 258.5 52.17 249.4 61.25L155.3 155.3C149.1 161.6 138.9 161.6 132.7 155.3C126.4 149.1 126.5 138.9 132.7 132.7L226.7 38.63C251.7 13.63 292.3 13.63 317.3 38.63L330.3 51.72L351 31.03C386.9-4.849 445.1-4.849 480.1 31.03C516.9 66.91 516.9 125.1 480.1 160.1L229.5 412.5C181.5 460.5 120.3 493.2 53.7 506.5L28.71 511.5C20.84 513.1 12.7 510.6 7.03 504.1C1.356 499.3-1.107 491.2 .4662 483.3L5.465 458.3C18.78 391.7 51.52 330.5 99.54 282.5L307.7 74.34L294.6 61.25zM208.1 218.3L293.7 303L458.3 138.3C481.7 114.1 481.7 77.05 458.3 53.66C434.1 30.27 397 30.27 373.7 53.66L208.1 218.3zM186.3 240.1L122.2 305.2C78.61 348.7 48.92 404.2 36.84 464.6L34.2 477.8L47.42 475.2C107.8 463.1 163.3 433.4 206.9 389.8L271 325.7L186.3 240.1z"
    ></path>
  </Svg>
);
export const CarIcon = () => (
  <Svg className="svg-inline--fa fa-car" aria-hidden="true" focusable="false" data-prefix="far" data-icon="car" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg="">
    <path
      fill="currentColor"
      d="M127.7 106.8L103.4 176H408.6l-24.2-69.2c-5.6-16-20.8-26.8-37.8-26.8H165.4c-17 0-32.1 10.7-37.8 26.8zm-79.6 82L82.3 90.9C94.7 55.6 128 32 165.4 32H346.6c37.4 0 70.7 23.6 83.1 58.9l34.3 97.9C492.6 205.4 512 236.4 512 272v80 48 56c0 13.3-10.7 24-24 24s-24-10.7-24-24V400H48v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V400 352 272c0-35.6 19.3-66.6 48.1-83.2zM416 224H96c-26.5 0-48 21.5-48 48v80H464V272c0-26.5-21.5-48-48-48zM112 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm256 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ></path>
  </Svg>
);
export const DurationIcon = () => (
  <Svg
    className="svg-inline--fa fa-timer"
    aria-hidden="true"
    focusable="false"
    data-prefix="fal"
    data-icon="timer"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    data-fa-i2svg=""
  >
    <path
      fill="currentColor"
      d="M512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 202.7 16.28 153.2 44.15 112.2C49.12 104.9 59.07 103 66.37 108C73.68 112.1 75.58 122.9 70.61 130.2C46.24 166.1 32 209.4 32 256C32 379.7 132.3 480 256 480C379.7 480 480 379.7 480 256C480 137.7 388.2 40.77 272 32.56V112C272 120.8 264.8 128 256 128C247.2 128 240 120.8 240 112V16C240 7.164 247.2 0 256 0C397.4 0 512 114.6 512 256V256zM267.3 244.7C273.6 250.9 273.6 261.1 267.3 267.3C261.1 273.6 250.9 273.6 244.7 267.3L148.7 171.3C142.4 165.1 142.4 154.9 148.7 148.7C154.9 142.4 165.1 142.4 171.3 148.7L267.3 244.7z"
    ></path>
  </Svg>
);
export const QuestionIcon = () => (
  <Svg
    className="svg-inline--fa fa-circle-question"
    aria-hidden="true"
    focusable="false"
    data-prefix="fal"
    data-icon="circle-question"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    data-fa-i2svg=""
  >
    <path
      fill="currentColor"
      d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 480c-123.5 0-224-100.5-224-224s100.5-224 224-224s224 100.5 224 224S379.5 480 256 480zM240 344c-13.25 0-24 10.75-24 24s10.75 24 24 24s24-10.75 24-24S253.3 344 240 344zM285.6 128H226.4C189.8 128 160 157.8 160 194.4V204c0 8.844 7.156 16 16 16S192 212.8 192 204V194.4C192 175.4 207.4 160 226.4 160h59.25C304.6 160 320 175.4 320 194.4c0 12.48-6.781 24-17.06 29.72L242.5 254.3C231.1 260.7 224 272.7 224 285.8V304C224 312.8 231.2 320 240 320S256 312.8 256 304V285.8c0-1.453 .7813-2.797 1.438-3.172l60.41-30.22C338.9 240.7 352 218.5 352 194.4C352 157.8 322.2 128 285.6 128z"
    ></path>
  </Svg>
);
export const LocationIcon = () => (
  <Svg
    className="svg-inline--fa fa-location-dot"
    aria-hidden="true"
    focusable="false"
    data-prefix="fal"
    data-icon="location-dot"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 384 512"
    data-fa-i2svg=""
  >
    <path
      fill="currentColor"
      d="M272 192C272 236.2 236.2 272 192 272C147.8 272 112 236.2 112 192C112 147.8 147.8 112 192 112C236.2 112 272 147.8 272 192zM192 240C218.5 240 240 218.5 240 192C240 165.5 218.5 144 192 144C165.5 144 144 165.5 144 192C144 218.5 165.5 240 192 240zM384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192H384zM192 32C103.6 32 32 103.6 32 192C32 207.6 37.43 229 48.56 255.4C59.47 281.3 74.8 309.4 92.14 337.5C126.2 392.8 166.6 445.7 192 477.6C217.4 445.7 257.8 392.8 291.9 337.5C309.2 309.4 324.5 281.3 335.4 255.4C346.6 229 352 207.6 352 192C352 103.6 280.4 32 192 32z"
    ></path>
  </Svg>
);
export const TickIcon = () => (
  <Svg
    className="svg-inline--fa fa-circle-check"
    aria-hidden="true"
    focusable="false"
    data-prefix="fal"
    data-icon="circle-check"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    data-fa-i2svg=""
  >
    <path
      fill="currentColor"
      d="M235.3 331.3C229.1 337.6 218.9 337.6 212.7 331.3L148.7 267.3C142.4 261.1 142.4 250.9 148.7 244.7C154.9 238.4 165.1 238.4 171.3 244.7L224 297.4L340.7 180.7C346.9 174.4 357.1 174.4 363.3 180.7C369.6 186.9 369.6 197.1 363.3 203.3L235.3 331.3zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 32C132.3 32 32 132.3 32 256C32 379.7 132.3 480 256 480C379.7 480 480 379.7 480 256C480 132.3 379.7 32 256 32z"
    ></path>
  </Svg>
);
export const UploadIcon = () => (
  <Svg className="svg-inline--fa fa-arrow-right-from-bracket" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
    <path
      fill="currentColor"
      d="M308.7 164.7C314.9 158.4 325.1 158.4 331.3 164.7L411.3 244.7C417.6 250.9 417.6 261.1 411.3 267.3C405.1 273.6 394.9 273.6 388.7 267.3L336 214.6V368C336 376.8 328.8 384 320 384C311.2 384 304 376.8 304 368V214.6L251.3 267.3C245.1 273.6 234.9 273.6 228.7 267.3C222.4 261.1 222.4 250.9 228.7 244.7L308.7 164.7zM272 32C331.5 32 384.1 61.55 416 106.8C430.5 99.87 446.8 96 464 96C525.9 96 576 146.1 576 208C576 218.7 574.5 228.1 571.7 238.8C612.3 260.2 640 302.9 640 352C640 422.7 582.7 480 512 480H144C64.47 480 0 415.5 0 336C0 273.2 40.15 219.9 96.17 200.1C100.3 106.6 177.4 32 272 32zM272 64C194.6 64 131.5 125 128.1 201.5C127.6 214.6 119.1 225.1 106.8 230.3C63.18 245.7 32 287.2 32 336C32 397.9 82.14 448 144 448H512C565 448 608 405 608 352C608 315.2 587.3 283.2 556.8 267.1C543.4 259.1 536.8 244.5 540.9 229.1C542.9 223 544 215.7 544 208C544 163.8 508.2 128 464 128C451.7 128 440.1 130.8 429.7 135.7C415.7 142.4 398.8 137.9 389.8 125.2C363.7 88.12 320.7 64 272 64V64z"
    />
  </Svg>
);
export const ExternalIcon = () => (
  <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path
      fill="currentColor"
      d="M336 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H457.4L212.7 276.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 54.6V176c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H336zM64 64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V304c0-8.8-7.2-16-16-16s-16 7.2-16 16V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H64z"
    />
  </Svg>
);

export const DownIcon = () => (
  <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <path fill="currentColor" d="M199 401c9.4 9.4 24.6 9.4 33.9 0L425 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L41 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L199 401z" />
  </Svg>
);

export const DollarIcon = () => (
  <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <path d="M176 64.78C207.7 67.45 237.9 73.82 259.8 79.15C268.4 81.24 273.6 89.89 271.5 98.48C269.5 107.1 260.8 112.3 252.2 110.2C219.2 102.2 170.2 92.71 127.9 96.25C106.8 98.02 88.75 102.9 75.32 111.7C62.43 120.2 53.01 132.6 49.36 151.9C46.56 166.7 48.33 177.5 52.35 185.7C56.46 194.2 63.66 201.6 74.26 208.4C96.21 222.4 128.3 230.9 164.1 240.3L165.7 240.7C199.4 249.5 236.3 259.2 262.9 276.2C276.9 285.1 288.1 296.5 296.4 311.8C303.1 327.3 305.9 345.2 302.1 365.5C295.6 399.8 271.4 422.9 239.4 435.4C220.8 442.7 199.2 446.6 176 447.4V496C176 504.8 168.8 512 160 512C151.2 512 144 504.8 144 496V446.5C137.8 445.1 131.5 445.3 125.1 444.3L125 444.3C98.79 440.4 59.31 431.4 25.67 416.9C17.55 413.4 13.81 403.1 17.31 395.9C20.81 387.8 30.22 384 38.33 387.5C68.67 400.6 105.3 409 129.7 412.7C168.6 418.2 202.8 415.4 227.7 405.6C252.2 396 266.7 380.3 270.6 359.6C273.4 344.8 271.7 334.1 267.6 325.8C263.5 317.4 256.3 309.9 245.7 303.2C223.8 289.2 191.7 280.6 155.9 271.2L154.3 270.8C120.6 262 83.71 252.3 57.06 235.4C43.14 226.5 31.01 215 23.57 199.7C16.05 184.2 14.07 166.3 17.91 146C23.2 118 37.72 98.08 57.81 84.94C77.36 72.16 101.3 66.38 125.2 64.37C131.4 63.85 137.7 63.58 144 63.51V16C144 7.164 151.2 0 160 0C168.8 0 176 7.164 176 16V64.78z" />
  </Svg>
);
